import * as React from 'react';
// Roboto was a dependency but never imported, so MUI fell back to Helvetica
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './context/Context';
import SocketProvider from './context/SocketContext';
import SocketNFCProvider from './context/SocketNFC';
import { BrowserRouter } from 'react-router-dom';
import { darkTheme } from './theme/theme';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// Strip every :hover rule as Emotion generates it; touch leaves :hover stuck on the last tap
const stripHoverPlugin = (element) => {
  if (element.type === 'rule') {
    const selector = Array.isArray(element.props)
      ? element.props.join(',')
      : String(element.value || '');
    if (selector.includes(':hover')) {
      element.children = [];
      element.return = '';
    }
  }
};

const emotionCache = createCache({
  key: 'css',
  prepend: true,
  stylisPlugins: [stripHoverPlugin],
});

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <CacheProvider value={emotionCache}>
    <ThemeProvider theme={darkTheme}>
      <AppProvider>
        <SocketProvider>
          <SocketNFCProvider>
            <CssBaseline />
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SocketNFCProvider>
        </SocketProvider>
      </AppProvider>
    </ThemeProvider>
  </CacheProvider>
);
